var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content conta"},[_vm._m(0),_c('b-tabs',{attrs:{"pills":"","nav-class":"mb-5 mt-5","lazy":""}},[_c('lista-jaleklinicos')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('span',[_c('i',{staticClass:"fas fa-briefcase-medical"}),_vm._v(" Jaleklinico")])])
}]

export { render, staticRenderFns }